export default __webpack_public_path__ + "static/media/filter-ico.a4bf8295.svg";